import { render, staticRenderFns } from "./InicioInterativo.vue?vue&type=template&id=3346a937&"
import script from "./InicioInterativo.vue?vue&type=script&lang=js&"
export * from "./InicioInterativo.vue?vue&type=script&lang=js&"
import style0 from "./InicioInterativo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports